import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { scrollReveal } from "./motionConstants";

interface WelcomeSectionProps {
  firstName: string;
  seasonLine?: string | null;
}

const WelcomeSection = ({ firstName, seasonLine }: WelcomeSectionProps) => {
  const { t } = useTranslation();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return t("good_morning", { name: firstName });
    if (hour < 18) return t("good_afternoon", { name: firstName });
    return t("good_evening", { name: firstName });
  };

  const subtitle = t("home_subtitle");
  const hasSubtitle = Boolean(subtitle && subtitle.trim());

  return (
    <motion.section {...scrollReveal} className="pt-2">
      <div className="w-10 h-1 rounded-full bg-gradient-to-r from-primary/60 to-primary/20 mb-3" />
      <h1 className="text-2xl md:text-3xl font-bold text-foreground tracking-tight">
        {getGreeting()}
      </h1>
      <p className="text-muted-foreground mt-1.5 text-base max-w-lg">
        {subtitle}
        {seasonLine && (
          <>
            {hasSubtitle && " · "}
            <span className="text-foreground/75">{t("greeting_season", { line: seasonLine })}</span>
          </>
        )}
      </p>
    </motion.section>
  );
};

export default WelcomeSection;
